export default Object.freeze({
    TEAM_STATUS_PENDING: 'pending',
    TEAM_STATUS_WAITING_LIST_PENDING: 'waiting_list_pending',
    TEAM_STATUS_WAITING_LIST_INVITED: 'waiting_list_invited',
    TEAM_STATUS_WAITING_LIST_JOINED: 'waiting_list_joined',
    TEAM_STATUS_WAITING_LIST_EXPIRED: 'waiting_list_expired',
    TEAM_STATUS_COMPLETED: 'completed',
    TEAM_STATUS_REMOVED: 'removed',
    TEAM_STATUS_MOVED: 'moved',
});



// WEBPACK FOOTER //
// ./src/Assets/components/Teams/consts/teamStatues.js